import React from 'react';
import { useSelected, useFocused } from 'slate-react';

import nodeControls from '../../node-menu/control-types';

import BaseElement from '../base';

import './index.scss';
import './resize.scss';

function Columns(props) {

  const element = props.element;
  const elementId = element.id;

  const selected = useSelected();
  const focused = useFocused();

  function renderColumns() {
    const { attributes, children } = props;
    const columnContainerAttributes = {
      ...attributes,
      className: 'column-wrapper'
    };
    const columnAttributes = {
      id: elementId,
      className: `columns-layout ${selected && focused ? 'selected' : ''}`,
      style: {
        'column-gap': `${element.properties?.columnSpacing || 5}px`
      }
    };

    return (
      <div {...columnContainerAttributes}>
        <div {...columnAttributes}>
          {children}
        </div>
      </div>
    );
  }

  function renderMain() {
    const baseElementProperties = {
      ...props,
      customNodeControls: [
        nodeControls.COLUMNS_COUNT_INPUT,
        nodeControls.COLUMN_SPACING_INPUT,
        nodeControls.ALIGNMENT
      ]
    };

    return (
      <BaseElement {...baseElementProperties}>
        {renderColumns()}
      </BaseElement>
    );
  }

  return renderMain();
}

export * from './column';

export default Columns;